<script lang="ts" setup></script>

<template>
  <v-chip class="bg-grey-darken-2" color="white" size="x-small"> Dismissed </v-chip>
</template>
